const sentinelHeightAboveButton = 750;

// promise function for finding DOM element only after it exists
function waitForElm(selector) {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}

waitForElm('.ais-InfiniteHits-loadMore').then((loadMore) => {
  // observer fires click action to load more hits
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        loadMore.click();
      }
    });
  });

  // element to be observed
  const sentinel = document.createElement('div');
  sentinel.id = 'sentinel';
  sentinel.style = `position: absolute; top: -${sentinelHeightAboveButton}px; left: 0px;`;
  
  // anchor to keep sentinel based on 'loadMore' button location
  const sentinelAnchor = document.createElement('div');
  sentinelAnchor.id = 'sentinel-anchor'
  sentinelAnchor.style = 'position: relative';
  sentinelAnchor.appendChild(sentinel);
  
  document.querySelector('.ais-InfiniteHits').append(sentinelAnchor);

  observer.observe(sentinel);
})